/* Posity — bezorgdatum. Handoff "Bezorgdatum in het koopblok" (augustus 2026).

   Vervangt de vaste tekst onder de voorraadstatus. Die klopte op de dag dat hij
   geschreven werd en daarna niet meer; een verkeerde bezorgbelofte verhoogt de
   conversie én de retouren tegelijk.

   WAAROM CLIENT-SIDE EN NIET IN LIQUID
   Liquid kent `now`, maar Shopify serveert productpagina's uit een cache: de
   datum zou dan bevroren raken op het moment van renderen en rond de cutoff
   een dag te vroeg blijven staan. Deze berekening draait daarom bij elke
   paginaweergave in de browser, en opnieuw als het tabblad na een tijd weer
   actief wordt. De Liquid-kant rendert een tekst die nooit fout kán zijn
   ("Levertijd 5 dagen"), zodat er zonder JavaScript geen datum staat in
   plaats van een verkeerde datum.

   Klassiek script met een global, geen ES-module: de PDP-sectie leest hem uit
   een inline script en dat kan niet importeren.

   LET OP — de orderbevestigingsmail moet dezelfde berekening doen, server-side.
   Staat daar een andere datum dan op de pagina, dan is het vertrouwen weg. Die
   mail valt buiten dit thema (Shopify-notificatie), dus dat is een losse taak.
*/
(function () {
  var NL_TZ = 'Europe/Amsterdam';
  /* Handoff "Bezorgbelofte in de buy box" (aug 2026). Verzenden en bezorgen zijn
     twee dingen: de verzendtermijn is ONZE belofte en mag hard, de bezorgdatum is
     de vervoerder en is een bereik. Geteld vanaf de verzenddag:
        verzenddag = de eerstvolgende dag dat het magazijn draait
        from = verzenddag + 2
        to   = verzenddag + 3
     De handoff telde er na de cutoff nog een dag bij op; dat is eruit, zie
     furnitureShipDay.
     Verzenddagen zijn ma t/m vr (het magazijn), bezorgdagen ma t/m za — DPD
     bezorgt op zaterdag. Die twee door elkaar halen kostte eerder drie dagen; zie
     de opmerking bij isDeliveryDay. */
  /* Transporttijd, in bezorgdagen ná de verzenddag. De handoff rekende +1 tot +3;
     dat bleek een dag te optimistisch (Anass, 3 aug 2026), dus werd het +2 tot +4.

     Op 7 aug 2026 terug naar +2 tot +3 (Anass): Tribesigns houdt zelf 2 werkdagen
     aan, dus de belofte gaat van "3 tot 7 dagen" naar "3 tot 5 dagen" en we
     kijken hoe dat loopt. Deze twee getallen zijn de bron van de regel
     "Verwachte bezorging"; de teksten elders zijn losse copy. Wijzig je hier
     iets, loop dan ook posity-pdp-accordion en de FAQ-blokken in
     templates/product.json na, anders belooft de ene regel iets anders dan de
     andere.

     Reken het na vanaf de BESTELDAG, niet vanaf de verzenddag: bestellen op dag 0
     betekent verzenden op dag 1 en bezorgen op dag 3 of 4. Valt er een zondag of
     feestdag tussen, dan schuift de bovengrens naar dag 5. Daarom dekt "3 tot 5"
     dit venster precies, en dekte "3 tot 7" het met twee dagen speling.

     Nagerekend voor elke besteldag, met zaterdag als verzenddag (7 aug 2026):
     ma 3-4 · di 3-5 · wo 3-5 · do 4-5 · vr 4-5 · za 4-5 · zo 3-4. Nergens boven
     de 5. Zet je zaterdag ooit weer uit als verzenddag, dan loopt vrijdag terug
     naar 5 tot 6 en klopt de belofte niet meer. */
  var LEAD_DAYS_FURNITURE_MIN = 2;
  var LEAD_DAYS_FURNITURE_MAX = 3;
  var CUTOFF_HOUR_FURNITURE = 17;
  /* Accessoires: 17:00 (Anass, 8 sep 2026). Verloop: handoff schreef 10:00 voor
     (altijd fout), daarna 17:00, per 1 aug 2026 22:00, per 22 aug 2026 19:00 en nu
     terug naar 17:00. Bestel je een accessoire vóór 17:00 op een werkdag, dan gaat
     hij dezelfde dag mee en is hij de volgende werkdag in huis.

     Sinds 8 sep 2026 staan meubels en accessoires allebei op 17:00. Ze blijven
     BEWUST twee losse constanten: het zijn twee afspraken met twee verschillende
     ketens (Monta voor accessoires, dropship voor meubels) en die kunnen weer uit
     elkaar lopen. Trek ze niet samen tot één getal.

     De zin "Voor <uur>:00 besteld, morgen in huis" bouwt zich uit deze constante op
     en volgt dus vanzelf. De ANDERE teksten niet: die staan los in
     snippets/posity-pdp-accordion (de is_org-tak) en de schema-default van
     sections/posity-faq. Wijzig je de cutoff hier, loop die dan na — anders belooft
     de ene regel iets anders dan de andere. Nagelopen op 8 sep 2026:
     posity-drawer-menu, posity-trust en templates/product.json noemen geen tijd
     meer, en in cart-summary is de regel helemaal verdwenen. */
  var CUTOFF_HOUR_ACCESSORY = 17;

  // "Nu" in Nederlandse tijd als losse velden — voorkomt UTC-verschuiving, zodat
  // een bezoeker in een andere tijdzone dezelfde datum ziet als het magazijn.
  function nowNL(base) {
    var d = base || new Date();
    var p = new Intl.DateTimeFormat('nl-NL', {
      timeZone: NL_TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    })
      .formatToParts(d)
      .reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
    return {
      date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
      // 24-uurs notatie geeft in sommige browsers "24" voor middernacht.
      hour: +p.hour % 24,
    };
  }

  // Anonieme Gregoriaanse computus — paaszondag voor een jaar. Bewust een
  // berekening en geen tabel: een tabel verloopt zonder dat iemand het merkt.
  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, month - 1, day));
  }

  function addDays(d, n) {
    var x = new Date(d.getTime());
    x.setUTCDate(x.getUTCDate() + n);
    return x;
  }
  function key(d) { return d.toISOString().slice(0, 10); }

  // Alleen dagen waarop niet bezorgd wordt. Goede Vrijdag, Bevrijdingsdag in
  // niet-lustrumjaren, Sinterklaas en oudejaarsdag staan er bewust niet bij:
  // daarop wordt gewoon bezorgd.
  var holidayCache = {};
  function holidaysNL(year) {
    if (holidayCache[year]) return holidayCache[year];
    var e = easterSunday(year);
    var kingsday = new Date(Date.UTC(year, 3, 27));
    if (kingsday.getUTCDay() === 0) kingsday.setUTCDate(26); // op zondag → 26 april
    var set = {};
    [
      new Date(Date.UTC(year, 0, 1)),   // Nieuwjaarsdag
      addDays(e, 1),                    // Tweede paasdag
      kingsday,                         // Koningsdag
      addDays(e, 39),                   // Hemelvaartsdag
      addDays(e, 50),                   // Tweede pinksterdag
      new Date(Date.UTC(year, 11, 25)), // Eerste kerstdag
      new Date(Date.UTC(year, 11, 26)), // Tweede kerstdag
    ].forEach(function (d) { set[key(d)] = true; });
    holidayCache[year] = set;
    return set;
  }

  /* Bezorgdag = elke dag behalve zondag en de feestdagen hierboven. ZATERDAG TELT
     WEL MEE: DPD bezorgt op zaterdag, alleen niet op zondag, en dat geldt zowel
     voor de meubels als voor de organizers (bevestigd 1 augustus 2026).

     Dit stond eerst op maandag t/m vrijdag, zoals de handoff schreef. Daardoor
     schoof er bij elk weekend twee dagen bij en kwam een bestelling van zaterdag
     1 augustus pas op maandag 10 augustus uit — negen dagen voor een belofte van
     vijf. Eén verkeerde aanname over zaterdag, drie dagen te laat. */
  function isDeliveryDay(d) {
    if (d.getUTCDay() === 0) return false; // zondag
    return !holidaysNL(d.getUTCFullYear())[key(d)];
  }

  function nextDeliveryDay(d) {
    var x = addDays(d, 1);
    while (!isDeliveryDay(x)) x = addDays(x, 1);
    return x;
  }

  /* Verzenddag ≠ bezorgdag, maar het verschil is sinds 7 aug 2026 kleiner: het
     magazijn verzendt ook op zaterdag (bevestigd door Anass). Alleen zondag en
     feestdagen vallen nog af, net als bij de bezorgdagen.

     Dit was de reden dat een vrijdagbestelling op maandag bleef hangen en pas op
     dag 5 of 6 werd bezorgd, buiten de belofte van "3 tot 5 dagen". Met zaterdag
     erbij gaat diezelfde bestelling de volgende dag weg en landt hij op dag 4 of
     5. Daarmee klopt de belofte op elke dag van de week, zonder aan de
     transporttijd te sleutelen. */
  function isShippingDay(d) {
    if (d.getUTCDay() === 0) return false; // zondag
    return !holidaysNL(d.getUTCFullYear())[key(d)];
  }
  function nextShippingDay(d) {
    var x = addDays(d, 1);
    while (!isShippingDay(x)) x = addDays(x, 1);
    return x;
  }

  function addDeliveryDays(d, n) {
    var x = d;
    for (var i = 0; i < n; i++) x = nextDeliveryDay(x);
    return x;
  }

  // timeZone UTC in de formatter: de datums hierboven zijn bewust UTC-middernacht,
  // dus omrekenen naar Amsterdam zou hem een dag terug kunnen zetten.
  function fmtNL(d) {
    return new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long',
    }).format(d);
  }

  // Zonder weekdag, voor het bereik: "5 augustus". De weekdag erbij maakt van
  // twee datums een lange zin die op mobiel afbreekt.
  function fmtDayMonth(d) {
    return new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'UTC', day: 'numeric', month: 'long',
    }).format(d);
  }
  // Korte vorm: "5 aug". De punt die nl-NL achter de afkorting zet gaat eruit —
  // in een belofteregel leest "5 – 7 aug." als het einde van een zin.
  function fmtDayMonthShort(d) {
    return new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'UTC', day: 'numeric', month: 'short',
    }).format(d).replace(/\.$/, '');
  }
  function fmtDay(d) {
    return new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', day: 'numeric' }).format(d);
  }
  function fmtWeekday(d) {
    return new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long' }).format(d);
  }

  /* Geeft de regel voor onder de voorraadstatus.
     kind: 'meubel' (5 bezorgdagen) of 'accessoire' (morgen in huis).
     base: optionele vaste datum, voor tests. */
  function note(kind, base, tier) {
    var n = nowNL(base);
    var today = n.date;

    if (kind === 'accessoire') {
      var onTime = isDeliveryDay(today) && n.hour < CUTOFF_HOUR_ACCESSORY;
      var target = onTime ? nextDeliveryDay(today) : nextDeliveryDay(nextDeliveryDay(today));
      // Alleen "morgen" zeggen als het ook echt morgen is: op vrijdag na de
      // cutoff of in het weekend is de eerstvolgende werkdag maandag.
      if (key(target) === key(addDays(today, 1))) {
        return 'Voor ' + CUTOFF_HOUR_ACCESSORY + ':00 besteld, morgen in huis';
      }
      return 'Bezorgd op ' + fmtNL(target);
    }

    /* Meubels: één vaste verzendbelofte. De bezorgdatum staat op de regel
       eronder (data-posity-delivery-range).

       Verzoek Anass, 22 aug 2026: geen weekdag en geen cutoff-zin meer, maar
       altijd "Binnen 24 uur verzonden". Hier stond eerder een berekening die op
       vrijdag, in het weekend en op feestdagen uitweek naar "verzonden op
       maandag" en anders "vandaag besteld, morgen verzonden" zei, plus een
       aparte zin voor de staat `few`.

       Let op wat dit betekent: de zin is nu een belofte en geen berekening meer.
       Bestelt iemand zaterdagmiddag, dan staat er nog steeds "binnen 24 uur
       verzonden" terwijl het magazijn maandag draait. Dat is een bewuste keuze
       van Anass; wil je hem weer waar máken, dan moet het magazijn in het weekend
       verzenden of moet deze zin terug naar een berekening.

       `tier` en de datumfuncties blijven hier ongebruikt maar staan nog in de
       signatuur: de accessoirelijn hierboven rekent wél, en rangeNote hieronder
       gebruikt dezelfde verzenddag.

       24 AUG 2026 (Anass): de verzendzin is eruit en de bezorgdatum komt hier
       staan. Meubels hebben nu ÉÉN regel — "Op voorraad · Bezorgd 27 – 28
       augustus" — in plaats van twee. De losse bezorgregel eronder is daarmee
       vervallen; die markup is uit posity-pdp.liquid gehaald.

       Waarom niet allebei: "Binnen 24 uur verzonden" en de bezorgdatum zeggen
       hetzelfde traject, en de klant onthoudt alleen wanneer het er is.

       25 AUG 2026 (Anass): geen venster meer maar één uiterste datum —
       "Uiterlijk 28 augustus in huis" i.p.v. "Bezorgd 27 – 28 augustus". Een
       bereik laat de klant zelf rekenen en klinkt als een slag om de arm; één
       datum is een belofte. Bewust de LAATSTE dag van het venster: eerder
       leveren dan beloofd kost niets, later wel.

       De berekening blijft furnitureLatest, dat op dezelfde verzenddag en
       dezelfde LEAD_DAYS_FURNITURE_MAX leunt als furnitureWindow. Die laatste
       staat er nog voor rangeNote; raak ze niet los van elkaar aan.

       `tier` blijft ongebruikt: bij 15 of minder vervangt het aantal deze zin al
       (stockUnits in de sectie), dus die staat komt hier niet langs. */
    return 'Uiterlijk ' + furnitureLatest(base) + ' in huis';
  }

  /* Verzenddag = de eerstvolgende dag dat het magazijn draait. Punt.

     De handoff schreef "vandaag vóór cutoff ? morgen : overmorgen" en telde er na
     de cutoff dus een dag bij op. Dat klopt niet met hoe het hier loopt (bevestigd
     door Anass, 2 aug 2026): een bestelling van zaterdag of zondag gaat maandag de
     deur uit, en een van woensdagavond gaat donderdag mee. Er valt buiten
     kantooruren geen cutoff te missen — het magazijn is dan gewoon dicht.

     Gevolg: de cutoff verschuift de verzenddag niet meer, en CUTOFF_HOUR_FURNITURE
     wordt hier niet meer gebruikt. Bewust laten staan: hij hoort bij de meubellijn
     en wordt elders nog genoemd. */
  function furnitureShipDay(n) {
    return nextShippingDay(n.date);
  }

  /* Het kale bezorgvenster van de meubellijn: "27 – 28 augustus".
     Zonder aanhef, zodat de aanroeper zijn eigen woord ervoor zet — "Bezorgd"
     in de voorraadregel, "Verwachte bezorging" in de losse bezorgregel. Bewust
     één functie en niet twee berekeningen: die hebben op deze pagina eerder twee
     verschillende datums opgeleverd. De vorm mag verschillen, de datum niet.

     Vallen beide datums in dezelfde maand, dan staat de maand er één keer. Komen
     ze op dezelfde dag uit (kan bij feestdagen), dan geen bereik maar één datum;
     "5 – 5 augustus" leest als een fout. En-dash met spaties, en bewust NIET het
     woord "tussen": dat is precies wat de zin onzeker laat klinken. */
  function furnitureWindow(base) {
    var ship = furnitureShipDay(nowNL(base));
    var from = addDeliveryDays(ship, LEAD_DAYS_FURNITURE_MIN);
    var to = addDeliveryDays(ship, LEAD_DAYS_FURNITURE_MAX);
    if (key(from) === key(to)) return fmtDayMonth(to);
    if (from.getUTCMonth() === to.getUTCMonth() && from.getUTCFullYear() === to.getUTCFullYear()) {
      return fmtDay(from) + ' – ' + fmtDayMonth(to);
    }
    return fmtDayMonth(from) + ' – ' + fmtDayMonth(to);
  }

  /* De LAATSTE dag van datzelfde venster, als losse datum: "28 augustus".
     Voor de belofte "Uiterlijk … in huis" (Anass, 25 aug 2026). Bewust de MAX en
     niet de min: een uiterste datum die je niet haalt is een gebroken belofte,
     en vroeger leveren dan beloofd kost niets. Zelfde berekening als
     furnitureWindow — één bron, anders lopen de twee ooit uiteen. */
  function furnitureLatest(base) {
    var ship = furnitureShipDay(nowNL(base));
    return fmtDayMonth(addDeliveryDays(ship, LEAD_DAYS_FURNITURE_MAX));
  }

  /* De bezorgregel voor meubels: "Verwachte bezorging 5 – 7 augustus".
     En-dash met spaties, en bewust NIET het woord "tussen": dat is precies wat de
     zin onzeker laat klinken (handoff, Copyregels).
     Vallen beide datums in dezelfde maand, dan staat de maand er één keer.
     Komen ze op dezelfde dag uit (kan bij feestdagen), dan geen bereik maar één
     datum; "5 – 5 augustus" leest als een fout. */
  function rangeNote(kind, base) {
    if (kind === 'accessoire') return '';
    return 'Verwachte bezorging ' + furnitureWindow(base);
  }

  /* Hetzelfde venster, kort: "5 – 7 aug". Voor de belofteregel onder de
     koopknop, waar de zin al begint met "Gratis bezorging" en de lange maandnaam
     hem in een 430px-kolom over twee regels duwt.

     Zelfde berekening als rangeNote — bewust dezelfde functies en niet een eigen
     variant. Twee losse berekeningen op één pagina hebben eerder twee
     verschillende data opgeleverd; de vorm mag verschillen, de datum niet.

     Leeg bij accessoires, net als rangeNote: die hebben geen bereik maar een
     morgen-in-huis-belofte, en die staat al in de voorraadregel. */
  function rangeShort(kind, base) {
    if (kind === 'accessoire') return '';
    var ship = furnitureShipDay(nowNL(base));
    var from = addDeliveryDays(ship, LEAD_DAYS_FURNITURE_MIN);
    var to = addDeliveryDays(ship, LEAD_DAYS_FURNITURE_MAX);
    if (key(from) === key(to)) return fmtDayMonthShort(to);
    if (from.getUTCMonth() === to.getUTCMonth() && from.getUTCFullYear() === to.getUTCFullYear()) {
      return fmtDay(from) + ' – ' + fmtDayMonthShort(to);
    }
    return fmtDayMonthShort(from) + ' – ' + fmtDayMonthShort(to);
  }

  window.PosityDelivery = {
    note: note,
    rangeNote: rangeNote,
    rangeShort: rangeShort,
    furnitureLatest: furnitureLatest,
    // Losse onderdelen naar buiten voor tests en hergebruik.
    isDeliveryDay: isDeliveryDay,
    nextDeliveryDay: nextDeliveryDay,
    addDeliveryDays: addDeliveryDays,
    easterSunday: easterSunday,
    format: fmtNL,
  };

  // Elk element met data-posity-delivery="meubel|accessoire" wordt gevuld.
  function paint() {
    var els = document.querySelectorAll('[data-posity-delivery]');
    for (var i = 0; i < els.length; i++) {
      var kind = els[i].getAttribute('data-posity-delivery') || 'meubel';
      // Voorraadstaat leest uit de wrapper: die bepaalt bij meubels de copy.
      var box = els[i].closest ? els[i].closest('[data-posity-stock]') : null;
      var tier = box && /posity-pdp__stock--(\w+)/.exec(box.className);
      els[i].textContent = note(kind, null, tier ? tier[1] : '');
    }
    // Bereikregel. Leeg (accessoire) → element verbergen in plaats van een lege
    // regel laten staan, anders houdt hij zijn marge.
    var ranges = document.querySelectorAll('[data-posity-delivery-range]');
    for (var j = 0; j < ranges.length; j++) {
      var rkind = ranges[j].getAttribute('data-posity-delivery-range') || 'meubel';
      var txt = rangeNote(rkind);
      ranges[j].textContent = txt;
      ranges[j].hidden = txt === '';
    }
    /* Korte vorm voor de belofteregel onder de koopknop. De regel staat er al
       zonder datum ("Gratis bezorging"); hier komt alleen het bereik erachter.

       Het (?)-cirkeltje hangt aan dezelfde staat: zonder datum valt er niets uit
       te leggen. Vandaar de vlag op de OUDER en niet op het element zelf — dan
       kan de CSS beide in één keer verbergen zonder een tweede haak. */
    var shorts = document.querySelectorAll('[data-posity-delivery-short]');
    for (var k = 0; k < shorts.length; k++) {
      var skind = shorts[k].getAttribute('data-posity-delivery-short') || 'meubel';
      var stxt = rangeShort(skind);
      shorts[k].textContent = stxt;
      // LET OP de -line: .posity-pdp__promise zónder suffix is de donatieregel
      // (snippets/posity-pdp-promise.liquid), een ander blok.
      var line = shorts[k].closest ? shorts[k].closest('.posity-pdp__promise-line') : null;
      if (line) line.classList.toggle('has-date', stxt !== '');
    }
  }

  // Herberekenen als het tabblad na lang openstaan weer actief wordt: anders
  // toont een pagina van gisteravond vanochtend nog de datum van gisteren.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paint();
  });
  document.addEventListener('posity:delivery:refresh', paint);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();
